

export class PropertyItemDocumentPurposeEnum {
    
	static Nothing: number = 0; 
	static PrimaryImage: number = 1; 
	static ReceivingImage: number = 2; 
	static StorageImage: number = 4; 
	static DamageImage: number = 8; 
	static RepairImage: number = 16; 
	static FinalPlacementImage: number = 32; 
	static InspectionImage: number = 64; 
	static SignatureImage: number = 262144; 
	static DoorJambImage: number = 524288; 
	static PickupImage: number = 1048576; 
	static DeliveryImage: number = 2097152; 


	static getChoices(): any[] {
		return [
		{
			Value: PropertyItemDocumentPurposeEnum.Nothing, Text: 'Nothing'
	},{
			Value: PropertyItemDocumentPurposeEnum.PrimaryImage, Text: 'Primary Image'
	},{
			Value: PropertyItemDocumentPurposeEnum.ReceivingImage, Text: 'Receiving Image'
	},{
			Value: PropertyItemDocumentPurposeEnum.StorageImage, Text: 'Storage Image'
	},{
			Value: PropertyItemDocumentPurposeEnum.DamageImage, Text: 'Damage Image'
	},{
			Value: PropertyItemDocumentPurposeEnum.RepairImage, Text: 'Repair Image'
	},{
			Value: PropertyItemDocumentPurposeEnum.FinalPlacementImage, Text: 'Final Placement Image'
	},{
			Value: PropertyItemDocumentPurposeEnum.InspectionImage, Text: 'Inspection Image'
	},{
			Value: PropertyItemDocumentPurposeEnum.SignatureImage, Text: 'Signature Image'
	},{
			Value: PropertyItemDocumentPurposeEnum.DoorJambImage, Text: 'Door Jamb Image'
	},{
			Value: PropertyItemDocumentPurposeEnum.PickupImage, Text: 'Pickup Image'
	},{
			Value: PropertyItemDocumentPurposeEnum.DeliveryImage, Text: 'Delivery Image'
	}
			
		];
	}

}
